import { useState } from 'react'
import { InputText } from 'primereact/inputtext'
import { Dropdown } from 'primereact/dropdown'
import { Calendar } from 'primereact/calendar'
import { InputSwitch } from 'primereact/inputswitch'
import { InputNumber } from 'primereact/inputnumber'
import { Slider } from 'primereact/slider'
import { Divider } from 'primereact/divider'

function FormElements() {
  const [userName, setUserName] = useState('')
  const [email, setEmail] = useState('')
  const [selectedOption, setSelectedOption] = useState(null)
  const [date, setDate] = useState<Date | null>(null)
  const [switchValue, setSwitchValue] = useState(false)
  const [numberValue, setNumberValue] = useState(50)

  const options = [
    { name: 'エクセル分析', value: 'excel' },
    { name: 'データ変換', value: 'data' },
    { name: 'レポート作成', value: 'report' },
    { name: '自動化設定', value: 'automation' }
  ]

  return (
    <div className="flex flex-column align-items-center">
      <h2 className="text-primary text-xl mb-3">フォーム要素</h2>
      <p className="text-lg mb-4">
        様々なフォーム入力要素の動作確認
      </p>

      <Divider />

      <div className="grid formgrid p-fluid w-full max-w-30rem">
        <div className="field col-12 mb-3">
          <span className="p-float-label">
            <InputText id="username" value={userName} onChange={(e) => setUserName(e.target.value)} className="w-full" />
            <label htmlFor="username">ユーザー名</label>
          </span>
        </div>

        <div className="field col-12 mb-3">
          <span className="p-float-label">
            <InputText id="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full" />
            <label htmlFor="email">メールアドレス</label>
          </span>
        </div>

        <div className="field col-12 mb-3">
          <Dropdown
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.value)}
            options={options}
            optionLabel="name"
            placeholder="処理タイプを選択"
            className="w-full"
          />
        </div>

        <div className="field col-12 mb-3">
          <Calendar
            value={date}
            onChange={(e) => setDate(e.value as Date)}
            showIcon
            dateFormat="yy年mm月dd日"
            className="w-full"
            placeholder="日付を選択"
          />
        </div>

        <div className="field col-12 mb-3">
          <div className="flex flex-column">
            <h3 className="mt-0 mb-2">数値入力: {numberValue}</h3>
            <InputNumber
              value={numberValue}
              onValueChange={(e) => setNumberValue(e.value ?? 50)}
              min={0}
              max={100}
              showButtons
            />
            <Slider
              value={numberValue}
              onChange={(e) => setNumberValue(Array.isArray(e.value) ? e.value[0] : e.value)}
              min={0}
              max={100}
              className="mt-3"
            />
          </div>
        </div>

        <div className="field col-12">
          <div className="flex align-items-center gap-2">
            <label htmlFor="switch" className="mr-2">機能を有効化:</label>
            <InputSwitch
              checked={switchValue}
              onChange={(e) => setSwitchValue(e.value as boolean)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FormElements
